export default function RightArrow() {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M8 12H17M17 12L13.087 8M17 12L13.087 16" stroke="#212121" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export const RightArrowGrey = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M3.375 9.5625H13.5M13.5 9.5625L9.70312 5.625M13.5 9.5625L9.70312 13.5" stroke="#7A7A7A" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}